module.exports = __webpack_public_path__ + "media/img/paygold/step2-f25dde7701b99328de985404fa61f7e4.png";